import { useRef, useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Loader2, Upload } from "lucide-react";

export const InvoiceFileUpload = ({ inv, onDone }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const upload = async (f) => {
    if (!f) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", f);
      await api.post(`/invoices/${inv.id}/file`, fd, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success("Invoice uploaded");
      onDone?.();
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setBusy(false); if (ref.current) ref.current.value = ""; }
  };
  return (
    <>
      <input ref={ref} type="file" accept=".pdf,.jpg,.jpeg,.png" className="hidden" onChange={(e) => upload(e.target.files?.[0])} data-testid={`upload-invoice-file-input-${inv.id}`} />
      <Button size="sm" variant="outline" className="border-red-400 text-red-700 hover:bg-red-50 dark:text-red-400" disabled={busy}
        onClick={() => ref.current?.click()} data-testid={`upload-invoice-file-${inv.id}`}>
        {busy ? <Loader2 className="mr-1 h-4 w-4 animate-spin" /> : <Upload className="mr-1 h-4 w-4" />} Upload invoice
      </Button>
    </>
  );
};
